// Copyright (C) 2021 TANNER AG

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import buildAssetUrl from "../utils/buildAssetUrl";
import EMobilityBanner from "../emobility/EMobilityBanner";

const styles = (theme) => ({
    root: {
        padding: 16,
        color: "#fff",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 180,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        textDecoration: "none",
        transition: "all 0.3s",
        boxShadow:
            "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",

        "&:hover": {
            boxShadow:
                "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px",
        },
    },
    disabled: {
        opacity: 0.4,
        userSelect: "none",
        boxShadow: "none",
        pointerEvents: "none",
        touchAction: "none",

        "& $number, & $title": {
            color: "#fff",
        },
    },
    title: {
        textTransform: "uppercase",
        color: "#fff",
        fontWeight: "bold",
        fontFamily: "MANEurope, Arial, sans-serif",
        fontSize: "1.6rem",
    },
    intro: {
        color: "#fff",
    },
    content: {
        maxWidth: 450,
    },
});

const getBuildAssetUrl = (image) => {
    if (!image) {
        return "";
    }

    const { url } = buildAssetUrl(image, 600);
    return url;
};

const BannerCard = withStyles(styles)(({ topic }) => {
    if (!topic) {
        return null;
    }

    const url = getBuildAssetUrl(topic.thumbnail);
    return (
        <React.Fragment>
            <EMobilityBanner heading={topic.title} description={topic.intro} src={url} minHeight={250} />
        </React.Fragment>
    );
});

export default BannerCard;



// WEBPACK FOOTER //
// ./src/transportsolutions/BannerCard.js